import {Worker} from "../util";

export default class LoginCtrl{
    static $resolve = {
        permissions: (UzivatelService) => UzivatelService.listPermissions().then(null, err => [])
    }
    
    
    constructor(permissions, UzivatelService){
        this.permissions = permissions;
        this.setPassword = Worker(this.setPassword);
        this.UzivatelService = UzivatelService
        this.oldPassword = "";
        this.newPassword = "";
        this.newPassword2 = "";
    }

    setPassword(){
        if(this.newPassword != this.newPassword2) throw new Error("Heslá sa nezhodujú")
        return this.UzivatelService.setMyPassword(this.oldPassword, this.newPassword).then(() => {
            this.oldPassword = this.newPassword = this.newPassword2 = "";
        });
    }


}


// WEBPACK FOOTER //
// ./src/auth/ProfileCtrl.js